import { Button, EButtonColor } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import './NewsletterReminder.scss';

export interface INewsletterReminderProps {
  visible: boolean;
  onClick: () => void;
}

export const NewsletterReminder: React.FC<INewsletterReminderProps> = ({ visible, onClick }) => {
  const { t } = useTranslation();
  const [hasSubscribed, setSubscribed] = React.useState(!visible);

  if (!visible) {
    return null;
  }

  const handleClick = () => {
    setSubscribed(true);
    onClick();
  };

  return (
    <div className="newsletter-reminder">
      <p>{t('Dashboard.NewsletterReminder.Text')}</p>
      <Button
        onClick={handleClick}
        disabled={hasSubscribed}
        className="newsletter-reminder-button"
        label={t('Dashboard.NewsletterReminder.Button')}
        color={EButtonColor.green}
      />
    </div>
  );
};

export default NewsletterReminder;
